<template>
    <div>
        <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
            <FormItem label="登录账号" prop="tel">
                <Input v-model="formCustom.tel" placeholder="请输入登录账号" @on-change="showtips=false" @keyup.enter.native="userEnterKey"></Input>
            </FormItem>
            <FormItem label="登录密码" prop="passwd">
                <Input type="password" v-model="formCustom.passwd" :password="showpwd" @on-change="showtips=false" @keyup.enter.native="userEnterKey"></Input>
            </FormItem>
            <FormItem>
                <Button type="primary" style="width: 100%;" @click="handleSubmit('formCustom')">登录</Button>
            </FormItem>
            <FormItem>
                <Button type="text" @click="createAccount">注册</Button>
                <Button type="text" @click="passwordReset">忘记密码？</Button>
            </FormItem>
            
        </Form>
        <Modal v-model="modalLoginActive" width="450" :mask-closable="false" :closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <!--  <Icon type="ios-paper" size="18" /> -->
                <span>账号激活</span>
            </p>
            <div style="height:130px;text-align: center;">
                <p>
                    <ActiveAccount ref="myactiveacc" />
                </p>
            </div>
            <div slot="footer" style="text-align: center;">
                <Button type="primary" size="large" @click="close">关闭</Button>
                <Button type="warning" size="large" @click="active">激活账号</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import { reqLoginActive } from '../../api/security/login'
import { mapActions, mapGetters } from 'vuex'
import store from '../../store/'
import activeAccount from './active-account.vue'
// import QRCode from 'qrcodejs2'
import ConstJson from "../../api/common/constjson.js"
let constJ = new ConstJson()
export default {
    name: 'UserLogin',
    data() {
        const validateTel = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入登录账号'));
            } else {
                if (this.checkAcc(value)) {
                    callback()
                } else {
                    callback(new Error('账号只能使用数字或字母,长度不超过12位'));
                }
            }
        };
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                // if (this.formCustom.passwdCheck !== '') {
                //   // 对第二个密码框单独验证
                //   this.$refs.formCustom.validateField('passwdCheck');
                // }
                callback();
            }
        };


        return {
            modalLoginActive: false,
            formCustom: {
                tel: '',
                passwd: '',
            },
            ruleCustom: {
                tel: [
                    { validator: validateTel, trigger: 'blur' }
                ],
                passwd: [
                    { validator: validatePass, trigger: 'blur' }
                ],
            },
            showtips: false,
            showpwd: false,
            //isShowQrcode:true,
        }
    },
    components: {
        'ActiveAccount': activeAccount,
        'scriptLink': {
            render(createElement) {
                return createElement(
                    'script', {
                        attrs: {
                            type: 'text/javascript',
                            src: 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js',
                        },
                    },
                )
            }
        }

    },
    methods: {
        // handleSubmit1(name) {
        //   this.$refs[name].validate((valid) => {
        //     if (valid) {
        //       this.showtips = false;
        //       this.$Message.success('登录成功!');
        //       //ajax 成功则关闭,并跳转至登录
        //       this.$emit('loginok');



        //       //token,userid,userguid,realname,permission[],mobilenum
        //       var loginUser = {
        //         userGuid: resp.userGuid,
        //         userId: resp.userId,
        //         phone: resp.mobilenum,
        //         realName: resp.realname,
        //         token: resp.token,
        //       }
        //       this.handleSetLoginUserinfo(loginUser)
        //       // console.log(this.formCustom);
        //     } else {
        //       //this.$Message.error('Fail!');
        //       this.showtips = true;
        //     }
        //   })
        // },

        //解析URL,返回URL参数对象
        // getUrlkey(url) {
        //     var params = {};
        //     var urls = url.split("?");
        //     //console.log('1_分割url:', urls)
        //     var arr = urls[1].split("&");
        //     //console.log('2_分割urls[1]:', arr)
        //     console.log(arr)

        //     for (var i = 0, l = arr.length; i < l; i++) {

        //         //去除#号部分
        //         var a = arr[i].split("=");
        //         //console.log('3_遍历 arr 并分割后赋值给a:', a[0], a[1])

        //         //去除值的#号部分
        //         params[a[0]] = a[1].split('#')[0];
        //         //console.log('4_a给params对象赋值:', params)
        //     }
        //     //console.log('5_结果:', params)
        //     return params;
        // },


        // qrCode(url) {
        //     let qrcode = new QRCode('qrcode', {
        //         width: 100, //图像宽度
        //         height: 100, //图像高度
        //         colorDark: "#000000", //前景色
        //         colorLight: "#ffffff", //背景色
        //         typeNumber: 4,
        //         correctLevel: QRCode.CorrectLevel.L //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
        //     })

        //     qrcode.clear() //清除二维码 
        //     qrcode.makeCode(url) //生成另一个新的二维码
        // },

        // getWXUrl() {
        //     //console.log(this.$baseConfig.wxRedirectUrl)
        //     let po = {
        //         //http_redirct: 'http://test0.holywiser.com/home',
        //         http_redirct: this.$baseConfig.wxRedirectUrl,
        //     }
        //     // var customeStyle = "data:text/css;base64,Lnd4X3FyY29kZSBpZnJhbWUgeyB3aWR0aDogMTYwcHg7IGhlaWdodDogMTYwcHg7IG1hcmdpbjogMDsgcGFkZGluZzogMDsgfQ0KLmxvZ2luUGFuZWwgeyBtYXJnaW46MDsgcGFkZGluZzogMDsgfQ0KLmxvZ2luUGFuZWwgLnRpdGxlLCAubG9naW5QYW5lbCAuaW5mbyB7IGRpc3BsYXk6IG5vbmU7IH0NCi5pbXBvd2VyQm94IC5xcmNvZGUgeyBtYXJnaW46IDA7IHdpZHRoOiAxNjBweDsgYm9yZGVyOiBub25lOyB9";
        //     console.log('getWXUrl======================>')
        //     constJ.reqWXUrl(po).then(res => {
        //         console.log(res)
        //         let urlData = this.getUrlkey(res.item.url)
        //         console.log(urlData)
        //         var obj = new WxLogin({
        //             self_redirect: false,
        //             id: "wx_login_container",
        //             appid: urlData.appid,
        //             scope: urlData.scope,
        //             redirect_uri: urlData.redirect_uri,
        //             state: urlData.state,
        //             style: "",
        //             href: "https://test.holywiser.com/pubcss/qr.css", //customeStyle,//
        //         });
        //         var qrcodeBox = document.getElementById("wx_login_container");
        //         var iframes = qrcodeBox.getElementsByTagName("iframe");
        //         var ifr = iframes[0]
        //         ifr.setAttribute("height", "260px;");
        //         ifr.setAttribute("width", "300px");
        //         //console.log(iframes[0])

        //     })

        // },
        // wexinLogin() {
        //     console.log('weixin login===>')
        //     this.isShowQrcode = true
        //     //this.$refs.qrcode.innerHTML=''
        //     //document.getElementById('qrcode').innerHTML = ''
        //     this.getWXUrl()
        // },
        close() {
            console.log('close=====>')
            this.modalLoginActive = false
        },
        //激活
        callback1(value) {
            console.log(value)
            let f = this.$refs.myactiveacc.formCustom
            let u = this.formCustom
            let po = {
                userid: u.tel,
                mobilenum: f.tel,
                smscode: f.sms,
            }
            if (value) {
                this.goactive(po)
            } else {
                this.$Message.warning('您的输入有误')
                return
            }
        },
        active() {
            this.$refs.myactiveacc.checkInput('formCustom', this.callback1)
        },
        goactive(payload) {
            var that = this
            reqLoginActive(payload).then(function(resp) {
                console.log(resp)
                if (resp.rtncode === 1) {
                    if (resp.rltcode === 1) {
                        that.$refs.myactiveacc.handleReset('formCustom')
                        that.modalLoginActive = false
                        that.$Modal.success({
                            title: '激活成功',
                            content: '系统已自动绑定激活账号使用的手机号码,请您重新登录'
                        });
                        // that.$Message.success('激活成功,系统已自动绑定激活账号使用的手机号码,请您重新登录')
                        return
                    } else {
                        that.$Message.warning(resp.rltdesc)
                        return
                    }
                } else {
                    that.$Message.warning(resp.rtndesc)
                    return
                }

            })
        },
        userEnterKey() {
            this.$emit('on-enterkey')
        },
        handleInputSubmit() {
            this.$emit('input-login')
        },
        handleSubmit(name) {
            //console.log(store.state.user.userGuid)
            //console.log(name)
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$emit('on-valid-success')
                    // let userid = this.formCustom.tel
                    // let tempid = store.state.user.userGuid
                    // let passwd = this.formCustom.passwd
                    var payload = {
                        userid: this.formCustom.tel,
                        tempid: store.state.user.userGuid,
                        passwd: this.formCustom.passwd,
                    }
                    //console.log(userid,tempid,passwd)
                    //console.log(store)
                    store._actions.handleLogin[0](payload)
                        .then(res => {
                            // console.log('2222222222222222222------->')
                            // console.log(res)
                            //res.rltcode=-3
                            this.showtips = false;
                            this.$Message.success('登录成功！');
                            this.$emit('loginok');
                        })
                        .catch(err => {
                            console.log(err)
                            if (err.rltcode === -3) {
                                this.modalLoginActive = true
                                this.$Message.error(err.rltdesc);
                                this.$emit('loginerr');
                                return
                            } else {
                                this.$emit('loginerr');
                                this.$Modal.info({
                                    title: '提示',
                                    content: err.rltdesc
                                });
                                //this.$Message.error(err.rltdesc);
                            }

                            //this.$emit('loginerr');
                            //console.log(err + "..")
                        })
                } else {
                    this.showtips = true;
                    this.$Message.error('请确认登录信息是否完整');
                    console.log("验证失败")
                }
            })

        },



        handleReset(name) {
            this.$refs[name].resetFields();
            this.showtips = false;
        },
        checkAcc(txt) {
            if (!(/^[0-9a-zA-Z_]{1,}$/.test(txt))) {
                return false;
            } else {
                return true;
            }
        },
        // checkPhone(phoneNum) {
        //   var phone = phoneNum;
        //   if (!(/^1[3|4|5|6|7|8|9]\d{9}$/.test(phone))) {
        //     //alert("手机号码有误，请重填");  
        //     return false;
        //   } else {
        //     return true;
        //   }
        // },
        createAccount() {
            this.$emit('createAccount');
        },
        passwordReset() {
            this.$emit('pwdReset');
        },
        ...mapActions(['handleSetLoginUserinfo']),
    },

}
</script>
<style lang="less" scope>
@font-face {
    font-family: 'iconfont1';
    /* project id 2108466 */
    src: url('//at.alicdn.com/t/font_2108466_t6fdrccd8ut.eot');
    src: url('//at.alicdn.com/t/font_2108466_t6fdrccd8ut.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_2108466_t6fdrccd8ut.woff2') format('woff2'),
        url('//at.alicdn.com/t/font_2108466_t6fdrccd8ut.woff') format('woff'),
        url('//at.alicdn.com/t/font_2108466_t6fdrccd8ut.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_2108466_t6fdrccd8ut.svg#iconfont') format('svg');
}

.iconfont1 {
    color: #19be6b;
    font-family: "iconfont1" !important;
    font-size: 30px;
    font-style: normal;
}
</style>